import { render } from "./embargo-warning.vue?vue&type=template&id=20c8ee5c&scoped=true&ts=true"
import script from "./embargo-warning.vue?vue&type=script&lang=ts"
export * from "./embargo-warning.vue?vue&type=script&lang=ts"

import "./embargo-warning.vue?vue&type=style&index=0&id=20c8ee5c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c8ee5c"]])

export default __exports__